
const aboutlending25 = {
    "About Lendingkart Jul’25": [
        {
            question: "What are the important details of the Bond offering?",
            answer: "Issuer Name: Lendingkart Finance Limited (LFL)" + "<br>" +
            "Security Name: LENDINGKART FINANCE LIMITED SR A 11.71 NCD 01JL25 FVRS1LAC" + "<br>" +
            "ISIN:INE090W07626"+ "<br>" +
            "Nature of Instrument: Senior, secured, rated, listed, redeemable, taxable, non-convertible debentures" + "<br>" +
            "Seniority: Senior" + "<br>" +
            "Date of Issue: 25th October 2023" + "<br>" +
            "Credit Rating: ICRA BBB+/Positive" + "<br>" +
            "Face Value: Rs 1,00,000/Unit" + "<br>" +
            "Coupon: Fixed" + "<br>" +
            "Coupon Rate: 11.71% p.a. (XIRR basis)" + "<br>" +
            "Coupon Frequency: Monthly"+ "<br>" +
            "Principal Repayment: At Maturity" + "<br>" +
            "Original Mode of Issue: Private Placement" + "<br>" +
            "Listing Details: Bombay Stock Exchange (BSE)" + "<br>" +
            "Maturity Date: 1st Jul’25" + "<br>" +
            "Tenor: 20 months" + "<br>" +
            "Debenture Trustee: Catalyst Trusteeship Limited"
                
            },

            {
                question: "What is the Security Cover for the Bond?",
                answer: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond (including Interest accrued)."
            },
            {
                question: "What are the important covenants that the Issuer has to adhere to?",
                answer: "a. The Capital Adequacy Ratio (Tier 1 and Tier 2 capital) shall not fall below 20%." + "<br>" +
                "b. Gross Non-Performing Assets as a % of average portfolio of the Company shall not increase beyond 5%" + "<br>" +
                "c. NNPA should be less than 3.50%" + "<br>" +
                "d. Cumulative Asset Liability mismatch should always be positive in all the buckets" + "<br>" +
                "e. On book leverage shall not increase beyond 4.00x."
            },
            {
                question: "Can I liquidate the bond before maturity?",
                answer: "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However, the liquidation will happen at a discount of 2% to the value of the bond."
            },
            {
                question: "How is the Yield to Maturity (YTM) is calculated?",
                answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
            }


    ]
  }
  
  export default aboutlending25;